import { PropsWithChildren } from 'react';
import { makeStyles } from '@material-ui/core';

import HomeWorkIcon from '@material-ui/icons/HomeWork';
import AssessmentIcon from '@material-ui/icons/Assessment';
import GroupsIcon from '@mui/icons-material/Groups';
import PersonIcon from '@mui/icons-material/Person';
import MenuIcon from '@material-ui/icons/Menu';
import SentimentVerySatisfiedRoundedIcon from '@mui/icons-material/SentimentVerySatisfiedRounded';

import LogoFull from './LogoFull';
import LogoIcon from './LogoIcon';
import {
  Settings as SidebarSettings,
  UserSettingsSignInAvatar,
} from '@backstage/plugin-user-settings';
import { SidebarSearchModal } from '@backstage/plugin-search';
import {
  Sidebar,
  sidebarConfig,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarPage,
  SidebarScrollWrapper,
  SidebarSpace,
  useSidebarOpenState,
  Link,
} from '@backstage/core-components';
import SearchIcon from '@material-ui/icons/Search';
import { MyGroupsSidebarItem } from '@backstage/plugin-org';
import GroupIcon from '@material-ui/icons/People';
import Diversity3Icon from '@mui/icons-material/Diversity3';

const useSidebarLogoStyles = makeStyles({
  root: {
    width: sidebarConfig.drawerWidthClosed,
    height: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    marginBottom: -14,
  },
  link: {
    width: sidebarConfig.drawerWidthClosed,
    marginLeft: 24,
  },
});

const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>
    </div>
  );
};

export const Root = ({ children }: PropsWithChildren<{}>) => (
  <SidebarPage>
    <Sidebar>
      <SidebarLogo />
      <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
        <SidebarSearchModal />
      </SidebarGroup>
      <SidebarDivider />
      {/* Global nav, not org-specific */}
      <SidebarGroup label="Menu" icon={<MenuIcon />}>
      <SidebarItem icon={HomeWorkIcon} to="/" text="Home" />
      <MyGroupsSidebarItem
        singularTitle="My Group"
        pluralTitle="My Groups"
        icon={GroupIcon}
      />
      <SidebarItem
        icon={PersonIcon}
        title="Users"
        text="Users"
        to="users-manager"
      />
      <SidebarItem
        icon={GroupsIcon}
        to="teams-manager"
        text="Teams"
        title="Teams"
      />

      <SidebarItem
        icon={SentimentVerySatisfiedRoundedIcon}
        to="personal-satisfaction-tracker"
        text="Your Satisfaction"
      />
      <SidebarItem
        icon={Diversity3Icon}
        to="teams-satisfaction"
        text="Team Satisfaction"
        />
        </SidebarGroup>

      {/* End global nav */}
      <SidebarDivider />
      <SidebarScrollWrapper>
        {/* Items in this group will be scrollable if they run out of space */}
      </SidebarScrollWrapper>
      <SidebarSpace />
      <SidebarDivider />
      <SidebarItem
        icon={AssessmentIcon}
        to="avalia-dxhub-bets"
        text="Bets Back Office"
      />
      <SidebarItem
        icon={SentimentVerySatisfiedRoundedIcon}
        to="dev-satisfaction-tracker"
        text="Satisfaction Tracker"
      />
      <SidebarGroup
        label="Settings"
        icon={<UserSettingsSignInAvatar />}
        to="/settings"
      >
        <SidebarSettings />
      </SidebarGroup>
    </Sidebar>
    {children}
  </SidebarPage>
);
